/* eslint-disable */
import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import BtnLoader from "../BtnLoader/BtnLoader";
import BASE_URL from "../auth/Baseurl";
import axios from "axios";
import SubmitButton from "./SubmitButton";
import Loading from "../loader/Loading";

const Feature = (props) => {
  const {
    blocks,
    setBlocks,
    ids,
    setIds,
    loaders,
    errorsFeature,
    setErrorsFeature,
    handleSubmit,
  } = props;
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChangeFeatures = async (e, index) => {
    const { value } = e.target;
    const isAlreadySelected = ids.includes(value);
    const updatedBlocks = [...blocks];
    const updatedErrors = [...errorsFeature];

    const isFeatureAlreadySelected = blocks.some(
      (block) => block.selectedFeature === value
    );

    if (isAlreadySelected) {
      const isCheckboxSelected = updatedBlocks.some(
        (block) =>
          block.selectedFeature === value && block.selectedCheckboxes.length > 0
      );

      if (!isCheckboxSelected) {
        setIds((prevIds) => prevIds.filter((id) => id !== value));
        updatedBlocks[index].selectedFeature = "";
        updatedBlocks[index].selectedId = [];
        updatedErrors[index] = { feature: true, checkboxes: true };
      }
    } else {
      if (!isFeatureAlreadySelected) {
        updatedBlocks[index].selectedFeature = value;
        updatedBlocks[index].selectedCheckboxes = [];
        updatedErrors[index] = { ...updatedErrors[index], feature: false };

        try {
          const response = await axios.get(`${BASE_URL}/feature/${value}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });
          setLoading(false);
          updatedBlocks[index].selectedId =
            response.data.feature.feature_detail || [];
        } catch (error) {
          setLoading(false);
          console.error("Error fetching feature details:", error);
        }
      } else {
        console.log("This feature is already selected in another block.");
      }
    }

    // Update all necessary state variables at once
    setIds(ids);
    setBlocks(updatedBlocks);
    setErrorsFeature(updatedErrors);
  };

  console.log("updated ids===?", ids);

  const handleCheckboxChange = (id, checked, index) => {
    const updatedBlocks = [...blocks];
    const updatedErrors = [...errorsFeature];

    updatedBlocks[index].selectedCheckboxes = checked
      ? [...updatedBlocks[index].selectedCheckboxes, id.toString()]
      : updatedBlocks[index].selectedCheckboxes.filter(
          (item) => item !== id.toString()
        );

    updatedErrors[index] = {
      ...updatedErrors[index],
      checkboxes: updatedBlocks[index].selectedCheckboxes.length === 0,
    };
    setBlocks(updatedBlocks);
    setErrorsFeature(updatedErrors);
  };

  const addBlock = () => {
    const newBlock = {
      id: uuidv4(),
      selectedFeature: "",
      selectedId: [],
      selectedCheckboxes: [],
    };
    setBlocks([...blocks, newBlock]);
    setErrorsFeature([...errorsFeature, { feature: true, checkboxes: true }]);
  };

  const removeBlock = (blockId) => {
    const updatedBlocks = blocks.filter((block) => block.id !== blockId);
    const updatedErrors = errorsFeature.filter(
      (_, idx) => blocks[idx].id !== blockId
    );
    setBlocks(updatedBlocks);
    setErrorsFeature(updatedErrors);
  };

  const GetData = () => {
    axios
      .get(`${BASE_URL}/feature`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setFeatures(res.data?.data || []);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    GetData();
  }, []);

  return (
    <>
      <div className="grid md:grid-cols-12 bg-white p-4 rounded-lg gap-4">
        <h3 className="text-xl font-bold text-center md:col-span-12">
          Features
        </h3>

        {blocks?.map((block, index) => (
          <>
            <div className="md:col-span-12">
              <select
                value={block.selectedFeature}
                onChange={(e) => handleChangeFeatures(e, index)}
                className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
              >
                <option disabled value="">
                  All categories
                </option>
                {features?.map((feature) => (
                  <option
                    key={feature.id}
                    value={feature.id}
                    disabled={ids.some((id) => id === feature.id)}
                  >
                    {feature.heading}
                  </option>
                ))}
              </select>
            </div>

            <ul
              style={{ paddingTop: "10px" }}
              className="fl-wrap filter-tags no-list-style ds-tg"
            >
              {block.selectedId?.map((item) => (
                <li key={item.id}>
                  <input
                    className="another_checkB_box"
                    type="checkbox"
                    id={item.id}
                    checked={block.selectedCheckboxes?.includes(
                      item.id.toString()
                    )}
                    onChange={(e) =>
                      handleCheckboxChange(item.id, e.target.checked, index)
                    }
                  />
                  <label
                    style={{ padding: "0px 20px 0px 6px" }}
                    htmlFor={item.id}
                  >
                    {item.sub_heading}
                  </label>
                </li>
              ))}
            </ul>

            <div className="md:col-span-12 text-left flex justify-end items-end">
              <button
                onClick={addBlock}
                className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
              >
                Add New Category
              </button>
            </div>

            <div className="md:col-span-12 text-left flex justify-end items-end">
              {blocks.length > 1 && (
                <button
                  onClick={() => removeBlock(block.id)}
                  className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
                >
                  Remove
                </button>
              )}
            </div>
          </>
        ))}

        <div className="md:col-span-12 text-left flex justify-end items-end gap-4">
          <button className="border border-[#3b4249] font-medium bg-[#54c4d9] rounded-md text-white px-8 py-3">
            {loaders ? <BtnLoader /> : <>Save as Draft</>}
          </button>
          <SubmitButton handleSubmit={handleSubmit} loaders={loaders} />
        </div>
      </div>
    </>
  );
};

export default Feature;
